import { useQuery } from 'data-fetching-client';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { PurchaseMotionCTA } from 'purchase-motions-components/components/PurchaseMotionCTA/PurchaseMotionCTA';
import { isApiName } from 'self-service-api/core/type-guards/apiName'; // TODO: fix this @jsamuelson, move to GMST
import { EVALUATE_IN_APP_QUERY } from '../../../__generated__/chirp/com/hubspot/purchase/motions/rpc/PurchaseMotionsEvaluationService.dfc.new';
import { APP } from '../../constants/tracking/App';
import { SingleSkeletonLoader } from '../components/SingleSkeletonLoader';
import { jsx as _jsx } from "react/jsx-runtime";
export const PurchaseMotionsByProductApiNameAndLocation = ({
  displayCount,
  location,
  productApiName,
  skipInterstitial
}) => {
  var _purchaseMotionsQuery;
  const purchaseMotionsQuery = useQuery(EVALUATE_IN_APP_QUERY, {
    variables: {
      productApiNames: [productApiName],
      locations: [location]
    }
  });
  if (purchaseMotionsQuery.error) {
    return null;
  }
  if (purchaseMotionsQuery.loading) {
    if (displayCount) {
      return Array.from({
        length: displayCount
      }, (__, index) => /*#__PURE__*/_jsx(SingleSkeletonLoader, {
        height: 40
      }, `purchase-motion-loader-${index}-${productApiName}-${location}`));
    }
    return /*#__PURE__*/_jsx(SingleSkeletonLoader, {
      height: 40
    });
  }
  const purchaseMotions = ((_purchaseMotionsQuery = purchaseMotionsQuery.data) === null || _purchaseMotionsQuery === void 0 || (_purchaseMotionsQuery = _purchaseMotionsQuery.result.purchaseMotionsMapping.productsByLocation[location]) === null || _purchaseMotionsQuery === void 0 ? void 0 : _purchaseMotionsQuery.purchaseMotionsByProductApiName[productApiName].purchaseMotions) || [];
  if (!purchaseMotions || purchaseMotions.length === 0) {
    return /*#__PURE__*/_jsx(View, {
      blockSize: "40px",
      inlineSize: "100%"
    });
  }

  // likely will never happen, but just in case
  if (!isApiName(productApiName)) {
    return null;
  }
  return /*#__PURE__*/_jsx(Flex, {
    flexDirection: "column",
    justifyContent: "center",
    gap: "200",
    inlineSize: "100%",
    children: Array.from({
      length: displayCount || purchaseMotions.length
    }, (__, displayIndex) => {
      const purchaseMotion = purchaseMotions[displayIndex];
      return /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(PurchaseMotionCTA, {
          apiName: productApiName,
          location: location,
          trackingData: {
            app: APP,
            screen: 'FAKE_SCREEN',
            // TODO: fix this @jsamuelson
            uniqueId: 'FAKE_UNIQUE_ID' // TODO: fix this @jsamuelson
          },
          purchaseMotion: purchaseMotion,
          uiButtonProps: {
            block: true,
            use: displayIndex === 0 ? 'primary' : 'secondary'
          },
          onClick: pm => {
            switch (pm) {
              case 'BUY_TOUCHLESS':
                // TODO: metrics trcking for buy touchless
                break;
              default:
                break;
            }
          },
          ctaProps: {
            currencyCode: 'USD',
            // TODO: fix this @jsamuelson
            terms: {
              commitmentTerm: 'ANNUAL',
              paymentTerm: 'ANNUAL'
            },
            // TODO: fix this  @jsamuelson
            requestedProducts: [{
              productApiName,
              quantity: 1
            }],
            skipInterstitial
          }
        })
      }, `purchase-motion-${purchaseMotion.toString()}`);
    })
  });
};